import { BlockUIContext } from '@/Shared/BlockUI/BlockUIContext'
import { useEffect, useContext } from 'react'
import { usePage } from '@inertiajs/react'

export default function VersionChecker() {
  const { version } = usePage().props
  const { setLoading } = useContext(BlockUIContext)

  useEffect(() => {
    const stored = localStorage.getItem('appVersion')

    if (stored && stored !== version) {
      setLoading(true) // Show overlay
      localStorage.setItem('appVersion', version)

      // Give time for UI to block before refreshing
      setTimeout(() => {
        window.location.reload(true)
      }, 100)
    } else {
      localStorage.setItem('appVersion', version)
    }
  }, [version])

  return null
}
